import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Propiedades from "@/pages/Propiedades";
import PropiedadDetalle from "@/pages/PropiedadDetalle";
import Legal from "@/pages/Legal";
import BuscaTuPiso from "@/pages/BuscaTuPiso";
import Visitas from "@/pages/Visitas";
import LlaveDigital from "@/pages/LlaveDigital";
import Admin from "@/pages/admin/Admin";

function LenisInit() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err)
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ink text-center text-ivory">
          <p className="font-serif text-2xl">Algo salió mal.</p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-full border border-gold/40 px-6 py-2 text-gold"
            data-testid="error-reload-button"
          >
            Recargar
          </button>
        </div>
      );
    return this.props.children;
  }
}

function SiteLayout() {
  return (
    <div className="grain min-h-screen bg-ink text-ivory">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/propiedades" element={<Propiedades />} />
        <Route path="/propiedades/:id" element={<PropiedadDetalle />} />
        <Route path="/busca-tu-piso" element={<BuscaTuPiso />} />
        <Route path="/visitas" element={<Visitas />} />
        <Route path="/legal/:slug" element={<Legal />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LenisInit />
        <ScrollToTop />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/llave-digital" element={<LlaveDigital />} />
          <Route path="*" element={<SiteLayout />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
